module.exports = require("@jswork/next");